module.exports = __webpack_public_path__ + "c3fd098acf04fbaa5e51f5fcfece6c73.pdf";